<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <v-container class="cen">
        <v-card class="card">
          <h4 class="bankT">Change Wallet Pin</h4>
          <v-row>
            <v-col>
              <div class="labelDiv">
                <label><b>Current Pin</b></label>
              </div>
              <v-text-field v-model="currentPin" type="password" outlined>
              </v-text-field>
              <div class="labelDiv">
                <label><b>New Pin</b></label>
              </div>
              <v-text-field v-model="NewPin" type="password" outlined>
              </v-text-field>
              <div class="labelDiv">
                <label><b>Confirm new PIN</b></label>
              </div>
              <v-text-field v-model="ConfirmPin" type="password" outlined>
              </v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="changePin()"
              large
              dark
              class="nextBtn"
              color="blue-grey"
            >
              Proceed
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-container>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";

export default {
  metaInfo: {
    title: "Teller/Change Password",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    Profile: Profile,
  },
  data: () => ({
    NewPin: "",
    ConfirmPin: "",
    currentPin: "",
  }),

  methods: {
    changePin() {
      if (this.NewPin == "" || this.ConfirmPin == "" || this.currentPin == "") {
        let payload = {
          status: true,
          message: "Fill out all the required field",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }
      if (this.NewPin != this.ConfirmPin) {
        let payload = {
          status: true,
          message: "Pin dont match",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }
      let payload = {
        Pin: this.NewPin,
        customerID: this.User.customerID,
        oldPIN: this.currentPin,
        route: this.$router,
      };
      this.$store.dispatch("ChangePin", payload);
    },
  },

  computed: {
    User() {
      return this.$store.getters.getUser;
    },
  },
};
</script>
<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody";
}
.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 50px;
  padding-top: 70px;
}
.cen {
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  padding: 20px;
  width: 600px;
  border-radius: 10px !important;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11) !important;
  background-color: #ffffff;
}

.bankT {
  text-align: center;
  color: #ad1684;
}
.cardR {
  margin: 10px;
  margin-left: 20px;
  margin-right: 20px;
}
.RlistM {
  overflow: scroll;
}
.maf {
  margin-right: 4px;
}
.select {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  background-color: #e3e3e3;
}

.selectDiv {
  position: relative;
}
.selectarrow {
  position: absolute;
  top: 15px;
  right: 10px;
  background-color: #ad1684;
}
.iconColor {
  color: white;
  font-size: 15px;
}
.nextBtn {
  background-color: #ad1684 !important;
  border-radius: 10px;
  text-transform: none;
}
.labelDiv {
  margin-bottom: 5px;
  margin-top: 5px;
}
@media only screen and (max-width: 1024px) {
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
